module.exports = __webpack_public_path__ + "130b04c79c988947e24fe4a0f9f220da.gif";